import { IntegrationMapper } from './IntegrationMapper.js';

class IntegrationRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getAllInboundIntegrations() {
    return this.apiClient.get('/v1/import/configurations/inbound').then(response => IntegrationMapper.getAllInboundIntegrationsModelFromResponse(response.data));
  }
}

export { IntegrationRepository };
//# sourceMappingURL=IntegrationRepository.js.map
